import React from 'react';

/** Eyebrow kicker + serif page title (use <em> for the gold emphasis word) + optional actions. */
export function LwPageHeader({
  eyebrow,
  title,
  actions
}: {
  eyebrow: string;
  title: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="topbar">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1 className="title">{title}</h1>
      </div>
      {actions}
    </div>
  );
}
